/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDataFromJSON, ApiDataToJSON, } from './ApiData';
import { ApiPageviewMetaTaggerFromJSON, ApiPageviewMetaTaggerToJSON, } from './ApiPageviewMetaTagger';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiReservedPageviewMetaFromJSON, ApiReservedPageviewMetaToJSON, } from './ApiReservedPageviewMeta';
export function ApiPageviewMetaFromJSON(json) {
    return ApiPageviewMetaFromJSONTyped(json, false);
}
export function ApiPageviewMetaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'data': !exists(json, 'data') ? undefined : ApiDataFromJSON(json['data']),
        'dataId': !exists(json, 'dataId') ? undefined : json['dataId'],
        'dataKey': !exists(json, 'dataKey') ? undefined : json['dataKey'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'pageviewMetaTaggerId': !exists(json, 'pageviewMetaTaggerId') ? undefined : json['pageviewMetaTaggerId'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'reserved': !exists(json, 'reserved') ? undefined : ApiReservedPageviewMetaFromJSON(json['reserved']),
        'tagger': !exists(json, 'tagger') ? undefined : ApiPageviewMetaTaggerFromJSON(json['tagger']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiPageviewMetaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'data': ApiDataToJSON(value.data),
        'dataId': value.dataId,
        'dataKey': value.dataKey,
        'id': value.id,
        'pageviewMetaTaggerId': value.pageviewMetaTaggerId,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'reserved': ApiReservedPageviewMetaToJSON(value.reserved),
        'tagger': ApiPageviewMetaTaggerToJSON(value.tagger),
        'value': value.value,
    };
}
